<template>
  <div
    v-if="allowQuantityPartials(bestPrice)"
    class="product-partials-fi"
  >
    {{ dict.get('online-Shop.Product.Allow-Partials') }}
  </div>
</template>

<script setup lang="ts">
import { useDict } from '@/composables/fischerPlugin';
import { useQuantityStepperPartials } from '@/composables/quantityStepperPartials';

interface BestPrice {
  partPackagingAllowed?: boolean | null;
  [key: string]: any;
}

interface Props {
  bestPrice?: BestPrice | null;
}

withDefaults(defineProps<Props>(), {
  bestPrice: null,
});

const { allowQuantityPartials } = useQuantityStepperPartials();
const dict = useDict();
</script>

<style scoped src="./product-partials-fi" />
